import React from 'react'

import styles from './style.module.scss'

interface DataType {
	title: string
	text: string
}

const data: DataType[] = [
	{
		title: 'Лояльны к кредитной истории',
		text: 'Если у вас когда-то были просрочки, это вряд ли станет стоп-фактором при рассмотрении заявки. Мы изучаем десятки показателей и составляем совокупный отчёт, по которому выносим решение.',
	},
	{
		title: 'Консультация через любые мессенджеры',
		text: 'Даём обратную связь по заявке в WhatsApp, Viber или Telegram. Поможем собрать документы и подскажем, как повысить шанс на одобрение сделки.',
	},
	{
		title: 'Можно получить деньги при наличии других долгов',
		text: 'Возможен вариант рефинансирования, чтобы объединить все кредиты в один и вносить единый ежемесячный платёж.',
	},
	{
		title: 'Подбираем максимально комфортные условия для каждого клиента',
		text: 'Мы используем ценностный подход при подборе оптимального варианта кредитования. Прорабатываем все возможные сценарии погашения долга клиентом, чтобы он не оказался в сложной ситуации.',
	},
	{
		title: 'Можно получить деньги без официального дохода',
		text: 'При оценке заявки смотрим на благосостояние человека в целом, анализируя множество других факторов',
	},
]

interface Props {
	title: string | React.ReactNode
	subtitle?: string | React.ReactNode
	customData?: DataType[]
}

export const CreditAlternative = ({ title, subtitle, customData }: Props) => {
	return (
		<div className='pt-l'>
			<div className={styles.infoBlock}>
				<h2>{title}</h2>
				<h3 className={styles.subtitle}>
					{subtitle || (
						<>Решение по заявке за полчаса. Получите до&nbsp;15 млн без похода в офисы и очередей</>
					)}
				</h3>
			</div>
			<div className={styles.points}>
				{(customData || data).map(({ text, title }) => (
					<div className={styles.point} key={title}>
						<h4>{title}</h4>
						<div className='mt-s'>{text}</div>
					</div>
				))}
			</div>
		</div>
	)
}
